import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Modal,
  Dimensions,
} from 'react-native';
import {useTranslation} from 'react-i18next';
import loadable from '@loadable/component';
import {useDispatch, useSelector} from 'react-redux';
import FabBackButton from '../../../../../../components/fab-back-button/FabBackButton.componet';

import {selectrootsheettype} from '../../../../../../selectors/SheetSelector';
import {showSheet} from '../../../../../../actions/SheetActions';
import SlideItems from './SlideItems';
import styles from './SliderLearn.style';
import Decription from '../../../../../pay-debt/components/Decription.component';
const {height} = Dimensions.get('window');
const SVG = loadable(() => import('../../../../../../imports/svg'));

const SliderLearn = () => {
  const dispatch = useDispatch();
  const {sheetProps} = useSelector(state => selectrootsheettype(state));
  const {t} = useTranslation();
  console.log(
    sheetProps?.selectedVehicle?.id,
    sheetProps?.selectedVehicle,
    'sheetProps',
  );
  const slides = [
    {
      img: 'Motorbyzin1',
      text: 'اجزای موتور با جعبه',
      Decription: [],
      zindesc: [],
      IconList: [
        {id: 1, name: 'جعبه', image: 'shop'},
        {id: 2, name: 'جک', image: 'jack'},
        {id: 3, name: 'چرخ', image: 'wheels'},
        {id: 4, name: 'فرمان', image: 'controller'},
        {id: 5, name: 'چراغ', image: 'lightlearn'},
        {id: 6, name: 'ترمز', image: 'brake'},
        {id: 7, name: 'بوق', image: 'belllearn'},
      ],
    },
    {
      img: 'motornozinrules',
      text: 'امنیت و مقررات',
      // Decription: [

      //   {
      //     id: 1,
      //     name: 'استفاده از کلاه ایمنی الزامیست.',
      //     image: 'ShieldWarning',
      //   },
      //   {id: 2, name: 'حداقل سن استفاده ۲۰سال است.', image: 'ShieldWarning'},
      //   {id: 3, name: 'در خط ویژه نرانید.', image: 'ShieldWarning'},
      //   {
      //     id: 4,
      //     name: 'رعایت قوانین راهنمایی و رانندگی الزامیست.',
      //     image: 'ShieldWarning',
      //   },
      //   {
      //     id: 5,
      //     name: 'از بوق برای جلب توجه رانندگان استفاده کنید.',
      //     image: 'ShieldWarning',
      //   },
      // ],
      IconList: [],
      Decription:
        sheetProps?.selectedVehicle?.Rules?.map(rule => ({
          id: rule.Id,
          name: rule.Title,
          image: 'ShieldWarning',
        })) || [],
      zindesc: [],
    },
  ];
  const slides1 = [
    {
      img: 'Motorbyzin2',
      text: 'اجزای موتور بدون جعبه',
      Decription: [],
      IconList: [
        {id: 6, name: 'ترمز', image: 'brake'},
        {id: 2, name: 'جک', image: 'jack'},
        {id: 3, name: 'چرخ', image: 'wheels'},
        {id: 4, name: 'فرمان', image: 'controller'},
        {id: 5, name: 'چراغ', image: 'lightlearn'},
        {id: 7, name: 'بوق', image: 'belllearn'},
      ],
      zindesc: [],
    },
    {
      img: 'motorzinrules',
      text: 'امنیت و مقررات',
      Decription:
        sheetProps?.selectedVehicle?.Rules?.map(rule => ({
          id: rule.Id,
          name: rule.Title,
          image: 'ShieldWarning',
        })) || [],
      IconList: [],
      zindesc: [],
    },
  ];

  const slides2 = [
    {
      id: 1,
      img: 'bicycleparts',
      text: 'اجزای دوچرخه',
      Decription: [],
      IconList: [
        {id: 1, name: 'سبد', image: 'shop'},
        {id: 2, name: 'جک', image: 'jack'},
        {id: 3, name: 'چرخ', image: 'wheels'},
        {id: 4, name: 'فرمان', image: 'controller'},
        {id: 5, name: 'پدال', image: 'vehiclepedal'},
        {id: 6, name: 'ترمز', image: 'brake'},
        {id: 7, name: 'زنگ', image: 'belllearn'},
      ],
      zindesc: [],
    },
    {
      id: 2,
      img: '',
      text: 'تنظیم زین دوچرخه ',
      Decription: [],
      IconList: [],
      zindesc: [],
      zindesc: [
        {id: 1, name: 'زین را متناسب با قدتان تنظیم کنید '},
        {
          id: 2,
          name: 'زاویه زانو در پایین‌ترین حالت پا، روی رکاب ۲۵ تا ۳۰ درجه است',
        },
        {
          id: 3,
          name: 'زاویه ۹۰ درجه می‌تواند به زانو و کمرتان آسیب بزند',
        },
      ],
    },
    {
      id: 3,
      img: 'bicyclerules',
      text: 'امنیت و مقررات',
      Decription:
        sheetProps?.selectedVehicle?.Rules?.map(rule => ({
          id: rule.Id,
          name: rule.Title,
          image: 'ShieldWarning',
        })) || [],
      IconList: [],
      zindesc: [],
      zindesc: [],
    },
  ];
  const closeSheet = () => {
    dispatch(showSheet({sheetId: ''}));
  };

  return (
    <Modal
      animationType="slide"
      transparent
      presentationStyle="overFullScreen"
      visible={sheetProps?.visible}
      onRequestClose={closeSheet}>
      <View style={styles.overlay}>
        <View style={styles.sheet}>
          <View style={styles.header}>
            <FabBackButton
              container_style={styles.closeBtn}
              onPress={closeSheet}
              icon={'closeIcon'}
            />
            <Text style={styles.headerTitle}>
              {sheetProps?.selectedVehicle?.title}
            </Text>
          </View>
          <SlideItems
            data={
              sheetProps?.selectedVehicle?.id === 2
                ? slides
                : sheetProps?.selectedVehicle?.id === 1
                ? slides1
                : slides2
            }
            id={sheetProps?.selectedVehicle?.icon}
          />
        </View>
      </View>
    </Modal>
  );
};

export default SliderLearn;
